// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__WH5BR","rootSuccess":"CompleteLink_rootSuccess__fTaqp","rootFailure":"CompleteLink_rootFailure__2QOCi","isDisabled":"CompleteLink_isDisabled__2jd-0"};